import { type Routes } from '@angular/router';

export const appointmentRoutes: Routes = [
  {
    path: '',
    redirectTo: 'visit-details',
    pathMatch: 'full',
  },
  {
    path: 'visit-details',
    loadComponent: () => import('./pages/visit-details/visit-details.page').then((m) => m.VisitDetailsPage),
    data: { background: 1 },
  },
  {
    path: 'waiting-room',
    loadComponent: () => import('./pages/waiting-room/waiting-room.page').then((m) => m.WaitingRoomPage),
    data: { background: 1 },
  },
];
